export const NEWSLETTER_SUBSCRIPTION_PERCENTAGE = 'percentage';
